module.exports = __webpack_public_path__ + "static/img/chat2.490d24d8.png";